import { SkeletonContainer } from './styles';

export const Skeleton = SkeletonContainer;
